// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2cd52bb","cardWrapper":"_09c0b94","card":"_a4d17bc"};